/// <reference path="./Container/CFlexContainer.ts" />
namespace HA.Core.HTML {
    export class Cite extends CFlexContainer {

        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("cite");
            const title = this.get("title");
            const img = this.get("img");
            if (img) {
                this.appendChild(new UImg(img));
            }else if(title) {
                const t = new Div({class: "ctitle", txt: title});
                this.appendChild(t);
            }
            const body = this.get("b");
            if (body) {
                const b = new Div({class: "cbody"});
                b.appendChild(new Tag(toMap(body)));
                this.appendChild(b);
            }
        }
    }
}
